import {
  MULTISELECT_ADD_ITEM,
  MULTISELECT_REMOVE_ITEM,
  MULTISELECT_CLEAR,
  MULTISELECT_ADD_ALL,
  UPDATE_MODAL_VISIBILITY
} from '../constants/multiselect-action-types'

export const addItemSelect = (item, keyCollection) => {
  return dispatch => {
    dispatch({
      type: MULTISELECT_ADD_ITEM,
      payload: {
        data: item,
        keyCollection: keyCollection
      }
    })
  }
}
export const addAll = (items, keyCollection) => {
  return dispatch => {
    dispatch({
      type: MULTISELECT_ADD_ALL,
      payload: {
        data: items,
        keyCollection: keyCollection
      }
    })
  }
}
export const cancelSelect = () => {
  return dispatch => {
    dispatch({
      type: MULTISELECT_CLEAR,
    })
  }
}

export const removeItemSelect = (item, keyCollection) => {
  return dispatch => {
    dispatch({
      type: MULTISELECT_REMOVE_ITEM,
      payload: {
        data: item,
        keyCollection: keyCollection
      }
    })
  }
}
export const updateModalVisibility = (data) => {
  return dispatch => {
    dispatch({
      type: UPDATE_MODAL_VISIBILITY,
      payload: data
    })
  }
}
